import { z } from "zod";
import { ForgeProjectInvitation, WorkspaceRoleSchema } from "@supernova-studio/model";

// Updated DTOs to match the database model
export const DTOForgeProjectInvitation = ForgeProjectInvitation;

export const DTOCreateForgeProjectInvitation = DTOForgeProjectInvitation.pick({
  email: true,
  role: true,
}).extend({
  workspaceRole: WorkspaceRoleSchema,
});

export const DTOUpdateForgeProjectInvitation = DTOCreateForgeProjectInvitation.omit({ email: true });

export const DTORemoveForgeProjectInvitation = DTOCreateForgeProjectInvitation.pick({
  email: true,
});

export const DTOForgeProjectInvitationsListResponse = z.object({
  invitations: z.array(DTOForgeProjectInvitation),
});

export const DTOForgeProjectInvitationGetResponse = z.object({
  invitation: DTOForgeProjectInvitation.nullable(),
});

export const DTOForgeProjectInvitationCreateResponse = z.object({
  invitation: DTOForgeProjectInvitation,
});

export const DTOForgeProjectInvitationUpdateResponse = z.object({
  invitation: DTOForgeProjectInvitation.nullable(),
});

export const DTOForgeProjectInvitationRemoveResponse = z.object({
  ok: z.literal(true),
});

export type DTOForgeProjectInvitation = z.infer<typeof DTOForgeProjectInvitation>;
export type DTOCreateForgeProjectInvitation = z.infer<typeof DTOCreateForgeProjectInvitation>;
export type DTOUpdateForgeProjectInvitation = z.infer<typeof DTOUpdateForgeProjectInvitation>;
export type DTORemoveForgeProjectInvitation = z.infer<typeof DTORemoveForgeProjectInvitation>;
export type DTOForgeProjectInvitationsListResponse = z.infer<typeof DTOForgeProjectInvitationsListResponse>;
export type DTOForgeProjectInvitationGetResponse = z.infer<typeof DTOForgeProjectInvitationGetResponse>;
export type DTOForgeProjectInvitationCreateResponse = z.infer<typeof DTOForgeProjectInvitationCreateResponse>;
export type DTOForgeProjectInvitationUpdateResponse = z.infer<typeof DTOForgeProjectInvitationUpdateResponse>;
export type DTOForgeProjectInvitationRemoveResponse = z.infer<typeof DTOForgeProjectInvitationRemoveResponse>;
